import { render } from "./order-list-action.vue?vue&type=template&id=0f082d89"
import script from "./order-list-action.vue?vue&type=script&lang=js"
export * from "./order-list-action.vue?vue&type=script&lang=js"

import exportComponent from "/builds/commerce/central/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__